import styled from "styled-components";
import Theme from "../../Styles/Themes";
import config from "../../Config/config.json"

export const Container = styled.div`
    display: flex;
    width: 90%;
    align-items: center;
    justify-content: ${props => props.$aling};
`;

export const TextParagraph = styled.p`
    display: flex;
    color: ${Theme[config.theme].colors.primaryFontColor};
    font-size: ${Theme[config.theme].font.paragraphs[config.fontSize].size};
    font-weight: ${Theme[config.theme].font.paragraphs[config.fontSize].weight};
    line-height: ${Theme[config.theme].font.paragraphs[config.fontSize].line_height};
`;